import { useState, useEffect } from "react";
import axios from "axios";
import { Star } from "lucide-react";
import { toast } from "react-toastify";
import { host } from "../../api/ApiCalls";

export default function RateUser({ targetId, currentRating, onSaved,}) {
  const [rating, setRating] = useState(Math.round(currentRating) || 0);
  const [hover, setHover] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  
  useEffect(() => {
    setRating(Math.round(currentRating) || 0);
  }, [currentRating]);

  const submit = async () => {
    setSubmitting(true);
    console.log("Submitting rating:", rating, "for targetId:", targetId);
    try {
        const token = await JSON.parse(localStorage.getItem("academiaHubToken"));
        console.log("Token:", token);
        console.log("Auth Header:", `Bearer ${token}`);

      const res = await axios.post(
        `${host}/api/auth/rate/${targetId}`,
        { value: rating },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
        console.log("Rating response:", res.data);
      toast.success(res.data.message);
      onSaved(res.data.rating);
    } catch (e) {
      console.error(e);
      toast.error("Failed to rate.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
       <div className="w-full bg-white p-5 rounded-xl shadow-md border border-gray-200 mt-4">
  <p className="text-sm text-gray-700 mb-3 font-medium text-center">
    {submitting ? "Saving your rating..." : "Click stars to rate"}
  </p>

  <div className="flex space-x-2 mb-4 justify-center">
    {[1, 2, 3, 4, 5].map((n) => (
      <Star
        key={n}
        size={30}
        onMouseEnter={() => setHover(n)}
        onMouseLeave={() => setHover(null)}
        onClick={() => setRating(n)}
        className={`cursor-pointer transition-transform duration-150 hover:scale-110 ${
          n <= (hover || rating)
            ? "fill-yellow-400 stroke-yellow-400"
            : "stroke-gray-300"
        }`}
      />
    ))}
  </div>

  <button
    onClick={submit}
    disabled={submitting}
    className="w-full px-4 py-2 text-sm font-semibold text-white bg-indigo-500 rounded-lg hover:bg-indigo-700 disabled:opacity-50 transition-all"
  >
    {rating ? "Submit Rating" : "Skip"}
  </button>
</div>


  );
}
